import React from 'react';

type BadgeVariant =
  | 'elementary' |'middle' |'high' |'free' |'pro' |'school' |'sdg' |'topic' |'duration' |'new' |'featured' |'default';

interface BadgeProps {
  variant?: BadgeVariant;
  children: React.ReactNode;
  className?: string;
}

const variantStyles: Record<BadgeVariant, string> = {
  elementary: 'bg-accent-50 text-accent-700 border border-accent-200',
  middle: 'bg-primary-50 text-primary-700 border border-primary-200',
  high: 'bg-terracotta-50 text-terracotta-700 border border-terracotta-200',
  free: 'bg-stone-100 text-stone-600 border border-stone-200',
  pro: 'bg-primary-50 text-primary-700 border border-primary-200',
  school: 'bg-accent-50 text-accent-700 border border-accent-200',
  sdg: 'bg-blue-50 text-blue-700 border border-blue-200',
  topic: 'bg-purple-50 text-purple-700 border border-purple-200',
  duration: 'bg-amber-50 text-amber-700 border border-amber-200',
  new: 'bg-emerald-50 text-emerald-700 border border-emerald-200',
  featured: 'bg-primary-500 text-white border-transparent',
  default: 'bg-stone-100 text-stone-600 border border-stone-200',
};

export default function Badge({ variant = 'default', children, className = '' }: BadgeProps) {
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium ${variantStyles[variant]} ${className}`}
    >
      {children}
    </span>
  );
}